import { render } from "./GSAxb.vue?vue&type=template&id=0aa4922a&scoped=true"
import script from "./GSAxb.vue?vue&type=script&lang=js"
export * from "./GSAxb.vue?vue&type=script&lang=js"

import "./GSAxb.vue?vue&type=style&index=0&id=0aa4922a&scoped=true&lang=css"
import "./GSAxb.vue?vue&type=style&index=1&id=0aa4922a&lang=css"
script.render = render
script.__scopeId = "data-v-0aa4922a"

export default script